export default __webpack_public_path__ + "static/media/img_map.060407d2.svg";